import React, { useContext } from 'react';

import PropTypes from 'prop-types';

import { Text, TextGroup, Title } from '@asteria/component-core/typography';

import { IntegrationsTeaser } from '@asteria/component-integrations-v2';

import { TranslationService } from '@asteria/language';
import { cn } from '@asteria/utils-funcs/classes';

import Actions from '../../components/actions';
import Placeholder from '../../components/placeholder';
import { ForecasterContext } from '../../context';
import { useForecastActionsQuery } from '../../hooks';

import './styles.scss';

const SectionActions = React.memo(() => {
	const { onAction, onSubmit } = useContext(ForecasterContext);

	const query = useForecastActionsQuery({ onSubmit });

	const actions = React.useMemo(
		() =>
			query?.data?.map((object) => ({
				...object,
				data: {
					type: object?.extra?.type,
					category: object?.tag?.category?.name,
					tag: object?.tag?.name,
					id: object?._id ?? object?.id,
				},
			})),
		[query?.data],
	);

	if (query?.isFetching) {
		return null;
	}

	if (!actions || !actions.length) {
		return (
			<div
				className={cn(
					'asteria-component__forecaster-page-section',
					'asteria--type-actions',
				)}
			>
				<TextGroup>
					<Title size="xs">
						{TranslationService.get([
							'forecaster.page.home.actions.title',
							'forecaster.page.home.actions.empty.title',
						])}
					</Title>
					<Text size="sm">
						{TranslationService.get([
							'forecaster.page.home.actions.text',
							'forecaster.page.home.actions.empty.text',
						])}
					</Text>
				</TextGroup>

				<IntegrationsTeaser onAction={onAction} onSubmit={onSubmit} />
				<Placeholder onAction={onAction} />
			</div>
		);
	}

	return (
		<div
			className={cn(
				'asteria-component__forecaster-page-section',
				'asteria--type-actions',
			)}
		>
			<TextGroup className="flex flex-col gap-1">
				<Title size="xs">
					{TranslationService.get([
						'forecaster.page.home.actions.title',
					])}
				</Title>
				<Text size="sm">
					{TranslationService.get([
						'forecaster.page.home.actions.text',
					])}
				</Text>
			</TextGroup>
			<IntegrationsTeaser onAction={onAction} onSubmit={onSubmit} />

			<Actions actions={actions} />
		</div>
	);
});

SectionActions.displayName = 'SectionActions';
SectionActions.propTypes = {
	onAction: PropTypes.func,
	onSubmit: PropTypes.func,
};

export default SectionActions;
